import { firebaseSdk } from './firebaseSdk'

export const storageSdk = firebaseSdk.storage
